import { c as _c } from "react/compiler-runtime";
import type { Option } from 'platform/components';
import { useState } from 'react';
import { Nullish, useOnMount } from 'shared/web';
import { useHttpCalls } from '../../../../../api/useHttpCalls';
const filterEmptyOptions = (options: Option[]): Option[] => options.filter(option => option.value.trim() !== '');
export function useSmartSearchHistory() {
  const $ = _c(10);
  const http = useHttpCalls();
  const [searchOptions, setSearchOptions] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  let t0;
  if ($[0] !== http) {
    t0 = () => {
      http.getSmartSearch().then(response => {
        if (response) {
          setSearchOptions(filterEmptyOptions(response));
        }
      });
    };
    $[0] = http;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fetchHistory = t0;
  useOnMount(fetchHistory);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMenuOpen(true);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const openMenu = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMenuOpen(false);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const closeMenu = t2;
  let t3;
  if ($[4] !== fetchHistory) {
    t3 = () => {
      fetchHistory();
    };
    $[4] = fetchHistory;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const refetch = t3;
  let t4;
  if ($[6] !== menuOpen || $[7] !== refetch || $[8] !== searchOptions) {
    t4 = {
      searchOptions,
      menuOpen,
      openMenu,
      closeMenu,
      refetch
    };
    $[6] = menuOpen;
    $[7] = refetch;
    $[8] = searchOptions;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}